import { ButtonTypes, UI, Stack } from '@genial/components';
import React from 'react';

interface HintButtonProps extends ButtonTypes.CompositeProps {
  tooltip?: string;
}

export const HintButton: React.FC<HintButtonProps> = ({ tooltip, children, ...buttonProps }) => {
  if (tooltip) {
    return (
      <UI.Tooltip label={tooltip}>
        <Stack>
          <UI.Button {...buttonProps}>{children}</UI.Button>
        </Stack>
      </UI.Tooltip>
    );
  }

  return <UI.Button {...buttonProps}>{children}</UI.Button>;
};
